import { all, takeEvery, put, fork } from "redux-saga/effects";
import { push } from "react-router-redux";

import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

export function* loadProductList() {
  yield takeEvery(actionTypes.MALL_LOAD_PRODUCT_LIST, function*(action) {
    try {
      const response = yield API.mallLoadProductList(action.id, action.data);
      if (response.data.success) {
        yield put(
          actions.mallLoadProductListSuccess(response.data, action.listType)
        );
      } else {
        alert(
          "Warning: Fail to load mall product list. \n" + response.data.message
        );
        yield put(actions.mallLoadProductListFail());
      }
    } catch (error) {
      yield put(
        actions.handleAPIError(error, "Fail to load mall product list. \n")
      );
      yield put(actions.mallLoadProductListFail());
    }
  });
}

export function* getProductProduct() {
  yield takeEvery(actionTypes.MALL_GET_PRODUCT_DETAIL, function*(action) {
    try {
      const response = yield API.mallGetProductDetail(
        action.shopID,
        action.productID
      );
      const data = response.data.data;

      if (response.data.success && data) {
        if (data.publish && data.deletedAt === null) {
          yield put(actions.mallGetProductDetailSuccess(response.data.data));
        } else {
          if (!data.publish) {
            alert("This product has been unpublished.");
          }
          if (data.deletedAt !== null) {
            alert("This product is no longer available.");
          }
          yield put(push("/mall/product/list"));
        }
      } else {
        alert(
          "Warning: Fail to get mall product detail. \n" + response.data.message
        );
        yield put(actions.mallGetProductDetailFail());
      }
    } catch (error) {
      yield put(
        actions.handleAPIError(error, "Fail to get mall product detail. \n")
      );
      yield put(actions.mallGetProductDetailFail());
    }
  });
}

export default function* mallProductSaga() {
  yield all([fork(loadProductList), fork(getProductProduct)]);
}
